import {
    /** FETCH APPLICATION  */
    FETCH_APPLICATIONNOTEPATIENT_FULFILLED,
    FETCH_APPLICATIONNOTEPATIENT_REJECTED,
    FETCH_APPLICATIONNOTEPATIENT_PENDING,
    RESET_APPLICATIONNOTEPATIENT,
} from "../../actions/application/applicationNotePatient";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APPLICATIONNOTEPATIENT_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_APPLICATIONNOTEPATIENT_FULFILLED:
            return {
                ...state,
                applicationNotePatient: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_APPLICATIONNOTEPATIENT_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_APPLICATIONNOTEPATIENT:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false,
            };
        default:
            return state;
    }
};